export default __webpack_public_path__ + "static/media/ja3.00419b19.jpeg";